import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'

let config = JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG_JSON)
let api = process.env.VUE_APP_API_URL
let stripeKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY

const firebaseApp = firebase.initializeApp(config)
// firebase.functions().useFunctionsEmulator('http://localhost:5000')

const strage = firebaseApp.storage()
const auth = firebaseApp.auth()
const firestore = firebaseApp.firestore()

export default firebaseApp.firestore()
// export {strage}
export { firebaseApp, firestore, firebase, strage, auth, api, stripeKey }
